import React from "react"
import { browserName, browserVersion } from "react-device-detect"
import { supportConfig } from "../../configs/supportConfig"
import env from "../../configs/envConfig"

const ReportBugLink = props => {
    const reportBugHandler = (e) => {
        const bugReportLink = `mailto:${supportConfig.supportContact}?${supportConfig.supportAuxiliary === undefined ? "" : `cc=${supportConfig.supportAuxiliary}&`}subject=${env.REACT_APP_BRANDING_SYMPHONY_TITLE}%20Issue%20Report&body=Description%3A%0APlease%20describe%20the%20problem%20you%27re%20having%20using%20the%20following%20sections%3A%0A1.%20Short%20Description%20of%20the%20issue%20you%20are%20seeing.%20Please%20be%20specific.%0A2.%20The%20expected%20result%20you%20are%20not%20getting.%0A3.%20Provide%20Steps%20to%20reproduce.%20Give%20individual%20steps%20that%20you%20took%20to%20find%20the%20issue.%0A4.%20Paste%20%2F%20Attach%20screenshots%20of%20the%20issue.%0A%0A%0A${new Date().toLocaleString("en-US", { month: "short", day: "numeric", year: "numeric", hour: "numeric", minute: "numeric" })}%0D%0Aby%20${props.reportedBy}%0D%0Ausing%20${browserName}%20v${browserVersion}`
        window.location.href = bugReportLink;
        e.preventDefault();
    }

    return (
        <li className="o-top-menu__link-item">
            <a href="#" className="o-top-menu__link" onClick={reportBugHandler}>
                Report an Issue &#x2197;
            </a>
        </li>
    )
}

export default ReportBugLink
